"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deepMerge = deepMerge;
exports.getPreparedPreloadedState = getPreparedPreloadedState;
var _ramda = require("ramda");
var _view = require("../types/view");
var _rememberedAccounts = require("../utils/rememberedAccounts");
function deepMerge(value1, value2) {
  if ((0, _ramda.type)(value1) === 'Object' && (0, _ramda.type)(value2) === 'Object') {
    return (0, _ramda.mergeWith)(deepMerge, value1, value2);
  } else if ((0, _ramda.isNil)(value2)) {
    return value1;
  } else {
    return value2;
  }
}
function getPreparedPreloadedState(config) {
  const isBrowserBuild = process.env.IS_BROWSER_BUILD;
  const rememberAccountsFlow = config.get('auth.rememberAccountsFlow.enabled');
  let isRememberAccountsFlow;
  if (isBrowserBuild) {
    const accounts = (0, _rememberedAccounts.getRememberedAccounts)();
    isRememberAccountsFlow = accounts.length !== 0 && rememberAccountsFlow || false;
  } else {
    isRememberAccountsFlow = rememberAccountsFlow || false;
  }
  const initialView = isRememberAccountsFlow ? _view.EActiveView.RememberedAccountsSelect : _view.EActiveView.PhoneAuth;
  const preparedPreloadedState = {
    view: {
      active: initialView
    },
    autoFocusDisabled: false,
    isRememberAccountsFlow
  };
  return preparedPreloadedState;
}